import { IGenericBaryFormGroup } from './GenericBaryFormGroup';
import { FormArray, FormGroup, ValidatorFn } from '@angular/forms';
import { BaryFormFactoryService } from '../../services/bary-form-factory.service';
import { FormGroupHelper } from './FormGroupHelper';
import { CarouselItemFormBuilder } from './builder/CarouselItemFormBuilder';
import { FaqItemFormBuilder } from './builder/FaqItemFormBuilder';
import { ThemeDataControls } from './builder/ThemeDataFormBuilder';
import { ThemeData } from '../theme-data.model';
import { CarouselItem } from '../carousel-item.model';
import { patchObject } from '../../app/shared/util/object-util';
import { FaqItem } from '../faq-item';

export class ThemeDataFormGroup extends FormGroupHelper implements IGenericBaryFormGroup<ThemeDataControls> {
  protected declare form: FormGroup;
  name = 'themeDataForm';
  updated = false;
  controls: ThemeDataControls;

  constructor(formName: string, controls: ThemeDataControls, validators?: ValidatorFn[]) {
    super();
    this.name = formName;
    this.form = this.newFormGroup(controls, validators);
    this.controls = controls;
  }

  getAngularForm(): FormGroup {
    return this.form;
  }

  updateForm(model: ThemeData): void {
    this.form.patchValue(model);
    this.updated = true;
  }

  addCarouselItem(carouselItem: CarouselItem, bcf: BaryFormFactoryService): void {
    const cif = new CarouselItemFormBuilder(bcf).init(carouselItem).build();
    this.controls.carouselItems.push(cif);
    const items = this.form.controls['items'] as FormArray;
    items.push(cif.getAngularForm());
  }

  removeCarouselItem(index: number): void {
    this.controls.carouselItems.splice(index, 1);
    const items = this.form.controls['items'] as FormArray;
    items.removeAt(index);
  }

  updateCarouselItem(carouselItem: CarouselItem, index: number): void {
    this.controls.carouselItems[index].updateForm(carouselItem);
  }

  addFaqItem(faqItem: { question: string; answer: string }, bcf: BaryFormFactoryService): void {
    const fif = new FaqItemFormBuilder(bcf).init(faqItem).build();
    this.controls.faqs.push(fif);
    const items = this.form.controls['items'] as FormArray;
    items.push(fif.getAngularForm());
  }

  removeFaqItem(index: number): void {
    this.controls.faqs.splice(index, 1);
    const items = this.form.controls['items'] as FormArray;
    items.removeAt(index);
  }

  updateFaqItem(faqItem: { question: string; answer: string }, index: number): void {
    this.controls.faqs[index].updateForm(faqItem);
  }

  value(): any {
    return this.form.value;
  }

  updateModel(model: ThemeData): void {
    patchObject(model, this.form.value);
    model.faqs = [];
    model.carouselItems = [];
    this.updateFaqModel(model.faqs);
    this.updateCarouselItemsModel(model.carouselItems);
  }

  updateFaqModel(faqs: FaqItem[]): void {
    this.controls.faqs.forEach(item => {
      faqs.push(item.value());
    });
  }

  updateCarouselItemsModel(carouselItems: CarouselItem[]): void {
    this.controls.carouselItems.forEach(item => {
      carouselItems.push(item.value());
    });
  }
}
